import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-preview',
  templateUrl: './text-preview.component.html',
  styleUrls: ['./text-preview.component.css']
})
export class TextPreviewComponent implements OnInit {
  @Input() text: string = '';
  @Input() maxLength: number = 100;
  @Input() classStyle: string = ''; // Se recibe la clase de estilo como input
  displayText: string = '';
  isHovered: boolean = false;

  ngOnInit() {
    this.updateDisplayText();
  }

  onMouseOver() {
    this.isHovered = true;
  }

  onMouseLeave() {
    this.isHovered = false;
  }

  private updateDisplayText() {
    if (this.text.length > this.maxLength) {
      const words = this.text.split(' ');

      if (words.length === 1) {
        // Si es solo una palabra, corta y agrega puntos suspensivos
        this.displayText = words[0].substring(0, this.maxLength) + '...';
      } else {
        // Si son múltiples palabras, se corta en el maxLength
        this.displayText = this.text.substring(0, this.maxLength) + '...';
      }
    } else {
      this.displayText = this.text;
    }
  }
}
